// Reference: https://msazure.visualstudio.com/One/_git/AD-MSA-AccountUX?path=%2Fsrc%2FProduct%2FWebRole%2FSource%2FResources%2FJs%2FInlineScripts%2FClientApi%2FPLTHelper.js&_a=contents&version=GBmaster

/**
 *Building the browser-perceived performance metrics object
 */
export var getPLTMetrics = function getPLTMetrics() {
  // performance.timing is deprecated while its substitution PerformanceNavigationTiming is under experiment and is not supported in IE and Safari
  // The ESTS team is still using performance.timing and they will discuss the replacement shortly.
  var timing = performance.timing;
  var metrics = {
    plt: getPLT(timing),
    dns: getDNSLookupTime(timing),
    tcp: getTCPConnectTime(timing),
    htmlDownload: getHTMLDownLoadTime(timing),
    domContentLoad: getDomContentLoadTime(timing),
    connect: getConnectTime(timing),
    request: getRequestTime(timing),
    response: getResponseTime(timing),
    load: getLoadTime(timing)
  };
  return metrics;
}; // DNS look up time

var getDNSLookupTime = function getDNSLookupTime(timing) {
  if (timing && timing.domainLookupEnd && timing.domainLookupStart) {
    //If a persistent connection is used, or the information is stored in a cache or a local resource, both values will be the same as PerformanceTiming.fetchStart.
    return timing.domainLookupEnd - timing.domainLookupStart;
  }

  return null;
}; // Time spent connecting to the server


var getTCPConnectTime = function getTCPConnectTime(timing) {
  if (timing && timing.connectEnd && timing.connectStart) {
    // If a persistent connection is used, both connectEnd and connectStart will be the same as PerformanceTiming.fetchStart.
    return timing.connectEnd - timing.connectStart;
  }

  return null;
}; // Time spent fetching the index HTML from server or cache


var getHTMLDownLoadTime = function getHTMLDownLoadTime(timing) {
  if (timing && timing.responseEnd && timing.requestStart) {
    return timing.responseEnd - timing.requestStart;
  }

  return null;
}; // Time spent drawing the render tree and execute deferred scripts.
// Script with async is not guaranteed to be included in this time range.
// This is acceptable as async script comes from third party and is acceptable.


var getDomContentLoadTime = function getDomContentLoadTime(timing) {
  if (timing && timing.domComplete && timing.domInteractive) {
    return timing.domComplete - timing.domInteractive;
  }

  return null;
}; // Time spent from when the navigation is initiated until the HTTP request is issued. This includes DNP and TCP connect time


var getConnectTime = function getConnectTime(timing) {
  if (timing && timing.navigationStart && timing.requestStart) {
    return timing.requestStart - timing.navigationStart;
  }

  return null;
}; // Time spent from when the HTTP request is issued until the first byte arrives at the client.


var getRequestTime = function getRequestTime(timing) {
  if (timing && timing.responseStart && timing.requestStart) {
    return timing.responseStart - timing.requestStart;
  }

  return null;
}; // Time spent from when the first byte received until the entire response of the HTML is received


var getResponseTime = function getResponseTime(timing) {
  if (timing && timing.responseEnd && timing.responseStart) {
    return timing.responseEnd - timing.responseStart;
  }

  return null;
}; // Time spent from when the HTML response has been downloaded until the browser fires the load event. This includes downloading all the resources and execution of script that is not marked with "async"


var getLoadTime = function getLoadTime(timing) {
  if (timing && timing.loadEventStart && timing.responseEnd) {
    return timing.loadEventStart - timing.responseEnd;
  }

  return null;
}; // Total time spent loading the page


var getPLT = function getPLT(timing) {
  if (timing && timing.loadEventStart && timing.navigationStart) {
    return timing.loadEventStart - timing.navigationStart;
  }

  return null;
};
//# sourceMappingURL=getPLTMetrics.js.map